export default "__VITE_ASSET__R9Y5FQgB__"